import { io } from 'socket.io-client';
import { ENVIRONMENT } from 'config';

const socket = io(`${ENVIRONMENT.BACKEND_API}/analytics`, {
  transports: ['websocket'],

});
export default socket;
